import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { GetDataDTO } from "../schema/Common/GetDataDTO";
import { CustomFieldsSelectValuesDTO } from "../schema/Subscription/CustomFieldsSelectValuesDTO";
import { UserCustomFieldDTO } from "../schema/Subscription/UserCustomFieldDTO";

@Injectable({
    providedIn: "root"
})
export class ApiCustomFieldsService {
    private relativePath = `${environment.subscription.url}/api/v1/subscription`;

    constructor(private httpClient: HttpClient) {}

    public CreateSelectValue(value: CustomFieldsSelectValuesDTO, subscriptionId: string): Observable<any> {
        return this.httpClient.post(
            `${this.relativePath}/${subscriptionId}/custom-fields/${value.fieldId}/select-value`,
            value
        );
    }

    public UpdateSelectValue(value: CustomFieldsSelectValuesDTO, subscriptionId: string): Observable<any> {
        return this.httpClient.put(
            `${this.relativePath}/${subscriptionId}/custom-fields/${value.fieldId}/select-value/${value.id}`,
            value
        );
    }

    public DeleteSelectValue(id: string, subscriptionId: string, fieldId: string): Observable<any> {
        return this.httpClient.delete(
            `${this.relativePath}/${subscriptionId}/custom-fields/${fieldId}/select-value/${id}`
        );
    }

    public GetSelectValues(
        subscriptionId: string,
        fieldId: string,
        skip: number,
        limit: number,
        find: string
    ): Observable<GetDataDTO<CustomFieldsSelectValuesDTO>> {
        let params = new HttpParams().set("skip", skip.toString()).set("limit", limit.toString());

        if (find) params = params.set("find", find);

        return this.httpClient.get<GetDataDTO<CustomFieldsSelectValuesDTO>>(
            `${this.relativePath}/${subscriptionId}/custom-fields/${fieldId}/select-value`,
            {
                params: params
            }
        );
    }

    AddCustomField(field: UserCustomFieldDTO, subscriptionId: string): Observable<UserCustomFieldDTO> {
        return this.httpClient.post<UserCustomFieldDTO>(`${this.relativePath}/${subscriptionId}/custom-fields`, field);
    }

    UpdateCustomField(field: UserCustomFieldDTO, subscriptionId: string): Observable<any> {
        return this.httpClient.patch(`${this.relativePath}/${subscriptionId}/custom-fields/${field.id}`, field);
    }

    RemoveCustomField(fieldId: string, subscriptionId: string): Observable<any> {
        return this.httpClient.delete(`${this.relativePath}/${subscriptionId}/custom-fields/${fieldId}`);
    }
}
